export default "__VITE_ASSET__D3gEP2kx__"